import { createTheme } from '@mui/material/styles';
import type { PaletteMode } from '@mui/material';
import { createContext } from 'react';

const primary = '#82CB16';
const neutrals = {
  900: '#111111',
  700: '#444444',
  600: '#666666',
  200: '#EDEDED',
};
const accent = '#6B7280';

export function getTheme(mode: PaletteMode) {
  const isDark = mode === 'dark';
  return createTheme({
    palette: {
      mode,
      primary: { main: primary, contrastText: '#ffffff' },
      secondary: { main: accent },
      background: {
        default: isDark ? '#161a1d' : '#ffffff',
        paper: isDark ? '#1b2024' : '#ffffff',
      },
      text: {
        primary: isDark ? '#e8eaed' : neutrals[900],
        secondary: isDark ? '#b0b6bd' : neutrals[600],
      },
      grey: neutrals as any,
    },
    typography: {
      fontFamily: 'Inter, Roboto, "Helvetica Neue", Arial, sans-serif',
      button: { fontWeight: 600 },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 14,
            boxShadow: isDark ? '0 1px 2px rgba(0,0,0,0.6)' : '0 1px 2px rgba(0,0,0,0.05)',
            ':hover': { boxShadow: isDark ? '0 2px 6px rgba(0,0,0,0.7)' : '0 2px 6px rgba(0,0,0,0.08)' },
          },
          containedPrimary: { color: '#fff' },
        },
      },
      MuiPaper: { styleOverrides: { root: { borderRadius: 16 } } },
      MuiCard: { styleOverrides: { root: { borderRadius: 16, boxShadow: isDark ? '0 2px 10px rgba(0,0,0,0.35)' : '0 2px 10px rgba(0,0,0,0.06)' } } },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root': {
              borderRadius: 12,
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: primary,
                boxShadow: '0 0 0 3px rgba(130,203,22,0.25)',
              },
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            borderRadius: 0,
            boxShadow: 'none',
            borderBottom: '1px solid',
            borderColor: isDark ? '#23292e' : '#E5E7EB',
          },
        },
      },
    },
  });
}

export const ColorModeContext = createContext<{ toggleColorMode: () => void }>({ toggleColorMode: () => {} });

export const theme = getTheme('light');
